import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"theme--light v-size--default primary",attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_c(VIcon,{attrs:{"dark":"","left":""}},[_vm._v("mdi-file-excel")]),_vm._t("default",function(){return [_vm._v("Download "+_vm._s(_vm.name))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }